import {_} from "core-js"
import Vue from "vue"

/**
 * ======================================================================
 *  REQUIRED FIELDS
 * ======================================================================
 */
let validate = {
    leadOverview: {
        assetType: true,
        assignTeam: Ambition.getGlobal("tenant").teams_enabled,
        assignTo: true,
        leadType: true,
        referralPartner: false,
        sellerType: true
    },
    assetInformation: {
        valuation: false,
        new: false,
        year: false,
        make: false,
        model: false,
        variant: false,
        subVariant: false,
        nvic: true,
        odometerReading: false,
        complianceDate: true
    },
    financeDetails: {
        applicationType: true,
        loanType: true,
        paymentType: true,
        amountToFinance: true,
        deposit: false,
        trade: false,
        payout: false,
        repaymentAmount: true,
        repaymentFrequency: true,
        repaymentTerm: true,
        balloon: false
    },
    consumerApplicantInformation: {
        title: true,
        firstName: true,
        middleName: false,
        lastName: true,
        phone: true,
        homePhone: false,
        email: true,
        email2: false,
        dob: true,
        maritalStatus: true,
        residentialStatus: true,
        licenseNumber: true,
        licenseExpiry: true,
        licenseState: true,
        licenseType: true
    },
    dependants: {
        age: true
    },
    residentialHistory: {
        unitNumber: false,
        streetNumber: true,
        streetName: true,
        suburb: true,
        state: true,
        postalCode: true,
        country: true,
        timeAtAddress: true,
        propertyStatus: true,
        rentAmount: true,
        rentFrequency: true,
        assetAmount: true,
        financier: true,
        limit: true,
        balance: true,
        repaymentAmount: true,
        frequency: true,
        totalMonths: true,
        startDate: true
    },
    investmentProperties: {
        unitNumber: false,
        streetNumber: true,
        streetName: true,
        suburb: true,
        state: true,
        postalCode: true,
        country: true,
        propertyStatus: true,
        income: false,
        incomeFrequency: false,
        assetAmount: true,
        financier: true,
        rate: false,
        limit: true,
        balance: true,
        repaymentAmount: true,
        frequency: true,
        totalMonths: true,
        startDate: true
    },
    employmentHistory: {
        occupation: true,
        employerName: true,
        employmentType: true,
        timeAtWork: true,
        phoneNumber: true,
        employerContact: true,
        businessActivity: true,
        abn: true,
        startDate: true,
        endDate: true,
        netIncome: true,
        incomeFrequency: true,
        grossYearly: true,
        unitNumber: false,
        streetNumber: true,
        streetName: true,
        suburb: true,
        state: true,
        postalCode: true,
        country: true
    },
    income: {
        income: false,
        totalIncome: true
    },
    incomeSummary: {
        hems: true,
        surplus: true,
    },
    assetAndLiabilitySummary: {
        netPosition: true,
    },
    assetsAndLiabilities: {
        assetValue: true,
        financier: true,
        limit: true,
        balance: true,
        repaymentAmount: true,
        frequency: true,
        totalMonths: true,
        startDate: true,
        year: true,
        nvic: true
    },
    unsecuredLiabilities: {
        financier: true,
        limit: true,
        balance: true,
        repaymentAmount: true,
        frequency: true,
        totalMonths: true,
        startDate: true
    },
    businessUnsecuredLiabilities: {
        financier: true,
        limit: true,
        balance: true,
        repaymentAmount: true,
        frequency: true,
        totalMonths: true,
        startDate: true
    },
    sharedAssetsAndLiabilities: {
        assetValue: true,
        financier: true,
        limit: true,
        balance: true,
        repaymentAmount: true,
        frequency: true,
        totalMonths: true,
        startDate: true,
        year: true,
        nvic: true
    },
    sharedUnsecuredLiabilities: {
        financier: true,
        limit: true,
        balance: true,
        repaymentAmount: true,
        frequency: true,
        totalMonths: true,
        startDate: true
    },
    expenses: {
        hems: true
    },
    references: {
        unitNumber: false,
        streetNumber: true,
        streetName: true,
        suburb: true,
        state: true,
        postalCode: true,
        country: true,
        name: true,
        phone: true,
        relationship: true
    },
    dealerDetails: {
        id: true,
        name: true,
        mobile: true,
        email: true
    },
    privateSellerDetails: {
        id: true,
        firstName: true,
        middleName: false,
        lastName: true,
        homePhone: false,
        phone: true,
        email: true,
        unitNumber: false,
        streetNumber: true,
        streetName: true,
        suburb: true,
        state: true,
        postalCode: true,
        country: true
    },
    businessInformation: {
        businessType: true,
        abn: true,
        registeredBusinessName: true,
        establishmentDate: true,
        gstRegistered: true,
        dateFirstRegisteredForGst: true,
        industryType: true,
        website: false,
        acn: false,
        description: false,
        unitNumber: false,
        streetNumber: true,
        streetName: true,
        suburb: true,
        state: true,
        postalCode: true,
        country: true,
        businessMobile: true,
        businessEmail: true,
        businessLandline: false,
        numberOfDirectors: true,
        accountantFirm: false,
        accountantContact: false,
        accountantPhone: false,
        accountantEmail: false
    },
    commercialApplicantInformation: {
        ownership: true,
        ownershipType: true,
        title: true,
        firstName: true,
        middleName: false,
        lastName: true,
        phone: true,
        homePhone: false,
        email: true,
        email2: false,
        dob: true,
        maritalStatus: true,
        residentialStatus: true,
        licenseNumber: true,
        licenseExpiry: true,
        licenseState: true,
        licenseType: true
    },
    businessAssetsLiabilities: {
        assetValue: true,
        financier: true,
        limit: true,
        balance: true,
        repaymentAmount: true,
        frequency: true,
        totalMonths: true,
        startDate: true,
        year: true,
        nvic: true,
        totalIncomeServicing: true
    },
    directDebit: {
        accountName: true,
        bsbNumber: true,
        accountNumber: true
    },
    emergencyContact: {
        first_name: true,
        last_name: true,
        phone: true,
        email: true,
        relationship: true
    },
    qualifyingQuestionnaire: {
        completed: true,
    },
}

/**
 * ======================================================================
 *  STATE
 * ======================================================================
 */

const state = {
    leadOverview: false,
    assetInformation: false,
    financeDetails: false,
    consumerApplicantInformation: [],
    dependants: [],
    residentialHistory: [],
    investmentProperties: [],
    employmentHistory: [],
    income: [],
    incomeSummary: [],
    assetAndLiabilitySummary: [],
    assetsAndLiabilities: [],
    unsecuredLiabilities: [],
    businessUnsecuredLiabilities: [],
    sharedAssetsAndLiabilities: [],
    expenses: [],
    financesSummary: [],
    references: [],
    emergencyContact: true,
    commercialApplicantInformation: [],
    sellerDetails: false,
    businessInformation: false,
    businessAssetsLiabilities: [],
    businessStructure: true,
    directDebit: true,
    debtServicing: true,
    commitmentSchedule: true,
    qualifyingQuestionnaire: false
}

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */

const getters = {}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */

const mutations = {

    // ====================================
    // Lead Overview
    // ====================================
    validateLeadOverview(state, validation) {
        let validateData = {}
        let leadOverview = {
            referralPartner: validation.data.referralPartner ? true : false,
            assignTo: validation.data.assignTo ? true : false,
            assignTeam: validation.data.assignTeam ? true : false,
            leadType: validation.data.leadType ? true : false,
            assetType: validation.data.assetType ? true : false,
            sellerType: validation.data.sellerType ? true : false,
        }
        for (const [key, value] of Object.entries(validate[validation.section])) {
            Vue.set(validateData, key, (value && !leadOverview[key] ? false : true))
        }
        state[validation.section] = Object.values(validateData).every(item => item === true)
    },

    // ====================================
    // Asset Information
    // ====================================
    validateAssetInformation(state, validation) {

        if (!_.isEmpty(validation.data)) {

            validate[validation.section] = {
                valuation: false,
                new: _.get(validation, 'data.assetTypeId', 0) == 6,
                year: _.get(validation, 'data.assetTypeId', 0) == 6,
                make: _.get(validation, 'data.assetTypeId', 0) == 6,
                model: _.get(validation, 'data.assetTypeId', 0) == 6,
                variant: false,
                subVariant: false,
                nvic: [1, 2, 3, 4].includes(_.get(validation, 'data.assetTypeId', 0)),
                odometerReading: false,
                complianceDate: _.get(validation, 'data.assetTypeId', 0) !== 5,
            }

            let validateData = {}
            let assetInformation = {
                valuation: validation.data.valuation ? true : false,
                new: validation.data.new ? true : false,
                year: validation.data.year ? true : false,
                make: validation.data.make ? true : false,
                model: validation.data.model ? true : false,
                variant: validation.data.variant ? true : false,
                subVariant: validation.data.subVariant ? true : false,
                nvic: validation.data.nvic ? true : false,
                odometerReading: validation.data.odometerReading ? true : false,
                complianceDate: validation.data.complianceDate ? true : false,
            }
            for (const [key, value] of Object.entries(validate[validation.section])) {
                Vue.set(validateData, key, (value && !assetInformation[key] ? false : true))
            }
            state[validation.section] = Object.values(validateData).every(item => item === true)
        } else {
            state[validation.section] = false
        }
    },

    // ====================================
    // Finance Details
    // ====================================
    validateFinanceDetails(state, validation) {
        let validateData = {}

        if (_.has(validation.data, 'amountToFinance') && validation.data.amountToFinance == "0.00") validation.data.amountToFinance = ""
        if (_.has(validation.data, 'repaymentAmount') && validation.data.repaymentAmount == "0.00") validation.data.repaymentAmount = ""

        let financeDetails = {
            applicationType: validation.data.applicationType ? true : false,
            loanType: validation.data.loanType ? true : false,
            paymentType: String(validation.data.paymentType) == "0" || String(validation.data.paymentType) == "1" ? true : false,
            amountToFinance: validation.data.amountToFinance ? true : false,
            deposit: validation.data.deposit ? true : false,
            trade: validation.data.trade ? true : false,
            payout: validation.data.payout ? true : false,
            repaymentAmount: validation.data.repaymentAmount ? true : false,
            repaymentFrequency: validation.data.repaymentFrequency ? true : false,
            repaymentTerm: validation.data.repaymentTerm ? true : false,
            balloon: validation.data.balloon ? true : false,
        }
        for (const [key, value] of Object.entries(validate[validation.section])) {
            Vue.set(validateData, key, (value && !financeDetails[key] ? false : true))
        }
        state[validation.section] = Object.values(validateData).every(item => item === true)
    },

    // ====================================
    // Applicant Details
    // ====================================
    validateConsumerApplicantInformation(state, validation) {
        let validateDataArray = []
        let applicantDetails = validation.data.map(applicant => {
            return {
                title: applicant.applicantTitle ? true : false,
                firstName: applicant.firstName ? true : false,
                lastName: applicant.lastName ? true : false,
                phone: applicant.phone ? true : false,
                homePhone: applicant.homePhone ? true : false,
                email: applicant.email ? true : false,
                email2: applicant.email2 ? true : false,
                dob: applicant.dob ? true : false,
                maritalStatus: applicant.maritalStatus ? true : false,
                residentialStatus: applicant.residentialStatus ? true : false,
                licenseNumber: applicant.licenseNumber ? true : false,
                licenseExpiry: applicant.licenseExpiry ? true : false,
                licenseState: applicant.licenseState ? true : false,
                licenseType: applicant.licenseType ? true : false,
            }
        })
        applicantDetails.forEach(applicantDetail => {
            let validateData = {}
            for (const [key, value] of Object.entries(validate[validation.section])) {
                Vue.set(validateData, key, (value && !applicantDetail[key] ? false : true))
            }
            validateDataArray.push(Object.values(validateData).every(item => item === true))
        })
        state[validation.section] = validateDataArray
    },

    // ====================================
    // Dependants
    // ====================================
    validateDependants(state, validation) {
        let validateDataArray = []

        let dependants = validation.data.map((applicant, key) => {
            let defaultOption = [{age: true}];
            if (!applicant.dependents) return defaultOption;
            return applicant.dependentsInfo.map(dependant => {
                return {
                    age: dependant.age ? true : false
                }
            })
        });

        dependants.forEach(applicant => {
            let validateDataMulti = []
            applicant.forEach(dependant => {
                let validateData = {}
                for (const [key, value] of Object.entries(validate[validation.section])) {
                    Vue.set(validateData, key, (value && (dependant[key] != value ? false : true)))
                }
                validateDataMulti.push(Object.values(validateData).every(item => item === true))
            })
            validateDataArray.push(validateDataMulti)
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Address Details
    // ====================================
    validateResidentialHistory(state, validation) {
        let validateDataArray = []

        let timeAtAddress = [];
        validation.data.forEach(applicant => {
            let months = 0
            applicant.addressHistoryInfo.forEach(address => {
                months += (address.timeFromYear ? Number(address.timeFromYear * 12) : 0) + (address.timeFromMonth ? Number(address.timeFromMonth) : 0)
            })
            timeAtAddress.push(months)
        })

        let allAddresses = validation.data.map(applicant => applicant.addressHistoryInfo).flat()
        let allAssetsAndLiabilities = validation.data.map(applicant => applicant.expandedFinancialDetails.assetsAndLiabilities).flat()

        let residentialHistory = validation.data.map((applicant, key) => {

            return applicant.addressHistoryInfo.map(address => {

                let expandedFinancials = applicant.expandedFinancialDetails
                let rent = {}
                let asset = {}
                let validateRentAmount = false
                let validateRentFrequency = false
                let validateAssetAmount = false
                let validateFinancier = false
                let validateLimit = false
                let validateRate = false
                let validateBalance = false
                let validateRepaymentAmount = false
                let validateFrequency = false
                let validateTotalMonths = false
                let validateStartDate = false

                let assetValue = ""
                let limit = ""
                let balance = ""
                let repaymentAmount = ""

                // if owned outright
                if (address.propertyStatus == 1) {

                    if (address.parent_id) {
                        let client_id = allAddresses.find(findAddress => findAddress.parent_id == address.parent_id).client_id
                        asset = allAssetsAndLiabilities.find(asset => _.has(asset, 'reference.id') && asset.reference.id === client_id)
                    } else {
                        asset = expandedFinancials.assetsAndLiabilities.find(asset => _.has(asset, 'reference.id') && asset.reference.id === address.client_id)
                    }

                    validateAssetAmount = true

                    assetValue = _.has(asset, 'assetValue') ? (asset.assetValue == "0.00" ? "" : asset.assetValue) : ""

                    // if mortgaged
                } else if (address.propertyStatus == 2) {

                    if (address.parent_id) {
                        let client_id = allAddresses.find(findAddress => findAddress.parent_id == address.parent_id).client_id
                        asset = allAssetsAndLiabilities.find(asset => _.has(asset, 'reference.id') && asset.reference.id === client_id)
                    } else {
                        asset = expandedFinancials.assetsAndLiabilities.find(asset => _.has(asset, 'reference.id') && asset.reference.id === address.client_id)
                    }

                    validateAssetAmount = true
                    validateFinancier = true
                    validateLimit = true
                    validateRate = true
                    validateBalance = true
                    validateRepaymentAmount = true
                    validateFrequency = true
                    validateTotalMonths = true
                    validateStartDate = true

                    assetValue = _.has(asset, 'assetValue') ? (asset.assetValue == "0.00" ? "" : asset.assetValue) : ""
                    limit = _.has(asset, 'limit') ? (asset.limit == "0.00" ? "" : asset.limit) : ""
                    balance = _.has(asset, 'balance') ? (asset.balance == "0.00" ? "" : asset.balance) : ""
                    repaymentAmount = _.has(asset, 'repaymentAmount') ? (asset.repaymentAmount == "0.00" ? "" : asset.repaymentAmount) : ""

                    // if renting
                } else {
                    validateRentAmount = true
                    validateRentFrequency = true
                    if (address.parent_id && expandedFinancials.sharedRent && expandedFinancials.sharedRent[0]) {
                        rent = expandedFinancials.sharedRent[0]
                    } else {
                        rent = expandedFinancials.expenses.leaseRent
                    }
                }

                return {
                    unitNumber: address.addressComponents.unit_number ? true : false,
                    streetNumber: address.addressComponents.street_number ? true : false,
                    streetName: address.addressComponents.route ? true : false,
                    suburb: address.addressComponents.locality ? true : false,
                    state: address.addressComponents.administrative_area_level_1 ? true : false,
                    postalCode: address.addressComponents.postal_code ? true : false,
                    country: address.addressComponents.country ? true : false,
                    timeAtAddress: timeAtAddress[key] >= 36 ? true : false,
                    propertyStatus: address.propertyStatus ? true : false,
                    rentAmount: validateRentAmount ? (_.has(rent, 'value') ? true : false) : true,
                    rentFrequency: validateRentFrequency ? (_.has(rent, 'frequency') ? true : false) : true,
                    assetAmount: validateAssetAmount ? (assetValue ? true : false) : true,
                    financier: validateFinancier ? (_.has(asset, 'financier') && asset.financier ? true : false) : true,
                    rate: validateRate ? (_.has(asset, 'rate') && asset.rate ? true : false) : true,
                    limit: validateLimit ? (limit ? true : false) : true,
                    balance: validateBalance ? (balance ? true : false) : true,
                    repaymentAmount: validateRepaymentAmount ? (repaymentAmount ? true : false) : true,
                    frequency: validateFrequency ? (_.has(asset, 'frequency') && asset.frequency ? true : false) : true,
                    totalMonths: validateTotalMonths ? (_.has(asset, 'totalMonths') && asset.totalMonths ? true : false) : true,
                    startDate: validateStartDate ? (_.has(asset, 'startDate') && asset.startDate ? true : false) : true,
                }
            })
        })

        residentialHistory.forEach(applicant => {
            let validateDataMulti = []
            applicant.forEach(address => {
                let validateData = {}
                for (const [key, value] of Object.entries(validate[validation.section])) {
                    Vue.set(validateData, key, (value && !address[key] ? false : true))
                }
                validateDataMulti.push(Object.values(validateData).every(item => item === true))
            })
            validateDataArray.push(validateDataMulti)
        })

        state[validation.section] = validateDataArray

    },

    // ====================================
    // Investment Properties
    // ====================================
    validateInvestmentProperties(state, validation) {
        let validateDataArray = []
        let investmentProperties = validation.data.map((applicant, key) => {

            return applicant.investmentPropertiesInfo.map(investment => {

                let expandedFinancials = applicant.expandedFinancialDetails
                let asset = {}
                let validateAssetAmount = false
                let validateFinancier = false
                let validateLimit = false
                let validateBalance = false
                let validateRepaymentAmount = false
                let validateFrequency = false
                let validateRate = false
                let validateTotalMonths = false
                let validateStartDate = false

                let assetValue = ""
                let income = ""
                let limit = ""
                let balance = ""
                let repaymentAmount = ""

                // if owned outright
                if (investment.propertyStatus == 1) {
                    asset = expandedFinancials.assetsAndLiabilities.find(asset => _.has(asset, 'reference.id') && asset.reference.id === investment.client_id)
                    validateAssetAmount = true

                    assetValue = _.has(asset, 'assetValue') ? (asset.assetValue == "0.00" ? "" : asset.assetValue) : ""
                    income = _.has(investment, 'income') ? (investment.income == "0.00" ? "" : investment.income) : ""

                    // if mortgaged
                } else if (investment.propertyStatus == 2) {

                    asset = expandedFinancials.assetsAndLiabilities.find(asset => _.has(asset, 'reference.id') && asset.reference.id === investment.client_id)
                    validateAssetAmount = true
                    validateFinancier = true
                    validateLimit = true
                    validateBalance = true
                    validateRepaymentAmount = true
                    validateFrequency = true
                    validateRate = true
                    validateTotalMonths = true
                    validateStartDate = true

                    assetValue = _.has(asset, 'assetValue') ? (asset.assetValue == "0.00" ? "" : asset.assetValue) : ""
                    income = _.has(investment, 'income') ? (investment.income == "0.00" ? "" : investment.income) : ""
                    limit = _.has(asset, 'limit') ? (asset.limit == "0.00" ? "" : asset.limit) : ""
                    balance = _.has(asset, 'balance') ? (asset.balance == "0.00" ? "" : asset.balance) : ""
                    repaymentAmount = _.has(asset, 'repaymentAmount') ? (asset.repaymentAmount == "0.00" ? "" : asset.repaymentAmount) : ""
                }

                return {
                    unitNumber: investment.addressComponents.unit_number ? true : false,
                    streetNumber: investment.addressComponents.street_number ? true : false,
                    streetName: investment.addressComponents.route ? true : false,
                    suburb: investment.addressComponents.locality ? true : false,
                    state: investment.addressComponents.administrative_area_level_1 ? true : false,
                    postalCode: investment.addressComponents.postal_code ? true : false,
                    country: investment.addressComponents.country ? true : false,
                    propertyStatus: investment.propertyStatus ? true : false,
                    income: income ? true : false,
                    incomeFrequency: investment.income_frequency ? true : false,
                    assetAmount: validateAssetAmount ? (assetValue ? true : false) : true,
                    financier: validateFinancier ? (_.has(asset, 'financier') && asset.financier ? true : false) : true,
                    rate: validateRate ? (_.has(asset, 'rate') && asset.rate ? true : false) : true,
                    limit: validateLimit ? (limit ? true : false) : true,
                    balance: validateBalance ? (balance ? true : false) : true,
                    repaymentAmount: validateRepaymentAmount ? (repaymentAmount ? true : false) : true,
                    frequency: validateFrequency ? (_.has(asset, 'frequency') && asset.frequency ? true : false) : true,
                    totalMonths: validateTotalMonths ? (_.has(asset, 'totalMonths') && asset.totalMonths ? true : false) : true,
                    startDate: validateStartDate ? (_.has(asset, 'startDate') && asset.startDate ? true : false) : true,
                }
            })
        })

        investmentProperties.forEach(applicant => {
            let validateDataMulti = []
            applicant.forEach(address => {
                let validateData = {}
                for (const [key, value] of Object.entries(validate[validation.section])) {
                    Vue.set(validateData, key, (value && !address[key] ? false : true))
                }
                validateDataMulti.push(Object.values(validateData).every(item => item === true))
            })
            validateDataArray.push(validateDataMulti)
        })

        state[validation.section] = validateDataArray

    },

    // ====================================
    // Employment History
    // ====================================
    validateEmploymentHistory(state, validation) {
        let validateDataArray = []
        let timeAtWork = [];
        validation.data.forEach(applicant => {
            let months = 0
            applicant.employmentHistoryInfo.forEach(employment => {
                months += (employment.years ? Number(employment.years * 12) : 0) + (employment.months ? Number(employment.months) : 0)
            })
            timeAtWork.push(months)
        })

        let employment = validation.data.map((applicant, key) => {

            return applicant.employmentHistoryInfo.map((employment, employmentKey) => {

                let employmentInformation = applicant.individualEmploymentInformation[employmentKey]

                return {
                    occupation: employment.occupation_id ? true : employment.occupation ? true : false,
                    employerName: employment.currentEmployer ? true : false,
                    employmentType: employment.employmentType ? true : false,
                    timeAtWork: timeAtWork[key] >= 36 ? true : false,
                    phoneNumber: employment.phoneNumber ? true : false,
                    employerContact: employment.employerContact ? true : false,
                    businessActivity: employment.businessActivity ? true : false,
                    abn: employment.abn && employment.abn.length == 11 ? true : false,
                    startDate: employment.start_date ? true : false,
                    endDate: !employment.is_current ? (employment.end_date ? true : false) : true,
                    netIncome: employment.is_current ? (_.has(employmentInformation, 'value') && parseFloat(employmentInformation.value) > 0 ? true : false) : true,
                    incomeFrequency: employment.is_current ? (_.has(employmentInformation, 'frequency') && employmentInformation.frequency ? true : false) : true,
                    grossYearly: employment.is_current ? (_.has(employmentInformation, 'grossYearly') && parseFloat(employmentInformation.grossYearly) > 0 ? true : false) : employment.gross_annual_income ? true : false,
                    unitNumber: employment.addressComponents.unit_number ? true : false,
                    streetNumber: employment.addressComponents.street_number ? true : false,
                    streetName: employment.addressComponents.route ? true : false,
                    suburb: employment.addressComponents.locality ? true : false,
                    state: employment.addressComponents.administrative_area_level_1 ? true : false,
                    postalCode: employment.addressComponents.postal_code ? true : false,
                    country: employment.addressComponents.country ? true : false,
                }
            })
        })

        employment.forEach(applicant => {
            let validateDataMulti = []
            applicant.forEach(address => {
                let validateData = {}
                for (const [key, value] of Object.entries(validate[validation.section])) {
                    Vue.set(validateData, key, (value && !address[key] ? false : true))
                }
                validateDataMulti.push(Object.values(validateData).every(item => item === true))
            })
            validateDataArray.push(validateDataMulti)
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Income
    // ====================================
    validateIncome(state, validation) {

        let validateDataArray = []
        let income = validation.data.map((applicant, key) => {
            let incomes = applicant.expandedFinancialDetails.income.map((income, incomeKey) => {
                return {
                    income: income.value !== "0.00" ? true : false,
                    totalIncome: applicant.totalMonthlyIncome !== "0.00" ? true : false,
                }
            })
            return incomes
        })

        income.forEach(applicant => {
            let validateDataMulti = []
            applicant.forEach(income => {
                let validateData = {}
                for (const [key, value] of Object.entries(validate[validation.section])) {
                    Vue.set(validateData, key, (value && !income[key] ? false : true))
                }
                validateDataMulti.push(Object.values(validateData).every(item => item === true))
            })
            validateDataArray.push(validateDataMulti)
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Income Summary
    // ====================================
    validateIncomeSummary(state, validation) {

        let validateDataArray = []
        let applicantStatus = $store.getters["hems/applicantStatus"]
        let note = $store.getters["hems/note"]
        let passedHems = Object.values(applicantStatus).every(item => item === true)
        let monthlySurplus = validation.extraData.availableMonthlySurplus
        applicantStatus = applicantStatus.map(status => {
            return {
                hems: status,
                surplus: monthlySurplus > 0 ? true : false,
            }
        })

        if (!passedHems && note) {
            applicantStatus = applicantStatus.map(status => {
                return {
                    hems: true,
                    surplus: monthlySurplus > 0 ? true : false,
                }
            })
        }

        applicantStatus.forEach(status => {
            let validateData = {}
            for (const [key, value] of Object.entries(validate[validation.section])) {
                Vue.set(validateData, key, (value && !status[key] ? false : true))
            }
            validateDataArray.push(Object.values(validateData).every(item => item === true))
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Asset and Liability Summary
    // ====================================
    validateAssetAndLiabilitySummary(state, validation) {
        let validateDataArray = []
        let netPosition = validation.extraData.netPosition

        let summary = [{
            netPosition: netPosition
        }]

        summary.forEach(status => {
            let validateData = {}
            for (const [key, value] of Object.entries(validate[validation.section])) {
                Vue.set(validateData, key, (value && !status[key] ? false : true))
            }
            validateDataArray.push(Object.values(validateData).every(item => item === true))
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Assets and Liabilities
    // ====================================
    validateAssetsAndLiabilities(state, validation) {
        let validateDataArray = []

        let assetsAndLiabilities = validation.data.map((applicant, key) => {

            return applicant.expandedFinancialDetails.assetsAndLiabilities.map((al, alKey) => {

                let isVehicle = false
                if (_.has(al, 'assetLiabilityType.value')) {
                    isVehicle = [
                        'MOTOR_VEHICLE',
                        'RECREATIONAL_ASSET',
                        'COMMERCIAL_VEHICLE'
                    ].includes(al.assetLiabilityType.value);
                }

                let assetValueZero = (_.has(al, 'assetValue') && al.assetValue == "0.00") ? "" : al.assetValue
                let limit = (_.has(al, 'limit') && al.limit == "0.00") ? "" : al.limit
                let balance = (_.has(al, 'balance') && al.balance == "0.00") ? "" : al.balance
                let repaymentAmount = (_.has(al, 'repaymentAmount') && al.repaymentAmount == "0.00") ? "" : al.repaymentAmount

                return {
                    assetValue: assetValueZero ? true : false,
                    financier: (assetValueZero || balance) && al.ownedOutright ? (al.financier ? true : false) : true,
                    limit: (assetValueZero || balance) && al.ownedOutright ? (limit ? true : false) : true,
                    balance: (assetValueZero || balance) && al.ownedOutright ? (balance ? true : false) : true,
                    repaymentAmount: (assetValueZero || balance) && al.ownedOutright ? (repaymentAmount ? true : false) : true,
                    frequency: (assetValueZero || balance) && al.ownedOutright ? (al.frequency ? true : false) : true,
                    totalMonths: (assetValueZero || balance) && al.ownedOutright ? (al.totalMonths ? true : false) : true,
                    startDate: (assetValueZero || balance) && al.ownedOutright ? (al.startDate ? true : false) : true,
                    year: (assetValueZero || balance) && isVehicle ? (al.year ? true : false) : true,
                    nvic: (assetValueZero || balance) && isVehicle ? (al.nvic ? true : false) : true,
                }
            })
        })

        assetsAndLiabilities.forEach(applicant => {
            let validateDataMulti = []
            applicant.forEach(address => {
                let validateData = {}
                for (const [key, value] of Object.entries(validate[validation.section])) {
                    Vue.set(validateData, key, (value && !address[key] ? false : true))
                }
                validateDataMulti.push(Object.values(validateData).every(item => item === true))
            })
            validateDataArray.push(validateDataMulti)
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Unsecured Liabilities
    // ====================================
    validateUnsecuredLiabilities(state, validation) {
        let validateDataArray = []

        let unsecuredLiabilities = validation.data.map((applicant, key) => {

            if (_.size(applicant.expandedFinancialDetails.liabilities) > 0) {
                return applicant.expandedFinancialDetails.liabilities.map((al, alKey) => {

                    let limit = (_.has(al, 'limit') && al.limit == "0.00") ? "" : al.limit
                    let balance = (_.has(al, 'balance') && al.balance == "0.00") ? "" : al.balance
                    let repaymentAmount = (_.has(al, 'repaymentAmount') && al.repaymentAmount == "0.00") ? "" : al.repaymentAmount

                    return {
                        financier: al.ownedOutright ? (al.financier ? true : false) : true,
                        limit: al.ownedOutright ? (limit ? true : false) : true,
                        balance: al.ownedOutright ? (balance ? true : false) : true,
                        repaymentAmount: al.ownedOutright ? (repaymentAmount ? true : false) : true,
                        frequency: al.ownedOutright ? (al.frequency ? true : false) : true,
                        totalMonths: al.ownedOutright ? (al.totalMonths ? true : false) : true,
                        startDate: al.ownedOutright ? (al.startDate ? true : false) : true
                    }
                })
            } else {
                return [{
                    financier: true,
                    limit: true,
                    balance: true,
                    repaymentAmount: true,
                    frequency: true,
                    totalMonths: true,
                    startDate: true
                }]
            }
        })

        unsecuredLiabilities.forEach(applicant => {
            let validateDataMulti = []
            applicant.forEach(unsecuredLiability => {
                let validateData = {}
                for (const [key, value] of Object.entries(validate[validation.section])) {
                    Vue.set(validateData, key, (value && !unsecuredLiability[key] ? false : true))
                }
                validateDataMulti.push(Object.values(validateData).every(item => item === true))
            })
            validateDataArray.push(validateDataMulti)
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Shared Assets and Liabilities
    // ====================================
    validateSharedAssetsAndLiabilities(state, validation) {
        let validateDataArray = []

        let sharedAssetsAndLiabilities = validation.data.map((applicant, key) => {

            if (_.get(applicant.expandedFinancialDetails, 'sharedLiabilities') && !_.isEmpty(applicant.expandedFinancialDetails.sharedLiabilities)) {
                return applicant.expandedFinancialDetails.sharedLiabilities.map((al, alKey) => {

                    let isVehicle = false
                    if (_.has(al, 'assetLiabilityType.value')) {
                        isVehicle = [
                            'MOTOR_VEHICLE',
                            'RECREATIONAL_ASSET',
                            'COMMERCIAL_VEHICLE'
                        ].includes(al.assetLiabilityType.value);
                    }

                    let assetValueZero = (_.has(al, 'assetValue') && al.assetValue == "0.00") ? "" : al.assetValue
                    let limit = (_.has(al, 'limit') && al.limit == "0.00") ? "" : al.limit
                    let balance = (_.has(al, 'balance') && al.balance == "0.00") ? "" : al.balance
                    let repaymentAmount = (_.has(al, 'repaymentAmount') && al.repaymentAmount == "0.00") ? "" : al.repaymentAmount

                    return {
                        assetValue: assetValueZero ? true : false,
                        financier: assetValueZero && al.ownedOutright ? (al.financier ? true : false) : true,
                        limit: assetValueZero && al.ownedOutright ? (limit ? true : false) : true,
                        balance: assetValueZero && al.ownedOutright ? (balance ? true : false) : true,
                        repaymentAmount: assetValueZero && al.ownedOutright ? (repaymentAmount ? true : false) : true,
                        frequency: assetValueZero && al.ownedOutright ? (al.frequency ? true : false) : true,
                        totalMonths: assetValueZero && al.ownedOutright ? (al.totalMonths ? true : false) : true,
                        startDate: assetValueZero && al.ownedOutright ? (al.startDate ? true : false) : true,
                        year: assetValueZero && isVehicle ? (al.year ? true : false) : true,
                        nvic: assetValueZero && isVehicle ? (al.nvic ? true : false) : true,
                    }
                })
            } else {
                return [{
                    assetValue: true,
                    financier: true,
                    limit: true,
                    balance: true,
                    repaymentAmount: true,
                    frequency: true,
                    totalMonths: true,
                    startDate: true,
                    year: true,
                    nvic: true,
                }]
            }
        })

        sharedAssetsAndLiabilities.forEach(applicant => {
            let validateDataMulti = []
            if (applicant) {
                applicant.forEach(address => {
                    let validateData = {}
                    for (const [key, value] of Object.entries(validate[validation.section])) {
                        Vue.set(validateData, key, (value && !address[key] ? false : true))
                    }
                    validateDataMulti.push(Object.values(validateData).every(item => item === true))
                })
                validateDataArray.push(validateDataMulti)
            }
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Shared Unsecured Liabilities
    // ====================================
    validateSharedUnsecuredLiabilities(state, validation) {
        let validateDataArray = []

        let sharedUnsecuredLiabilities = validation.data.map((applicant, key) => {

            if (_.get(applicant.expandedFinancialDetails, 'sharedUnsecuredLiabilities') && !_.isEmpty(applicant.expandedFinancialDetails.sharedUnsecuredLiabilities)) {

                return applicant.expandedFinancialDetails.sharedUnsecuredLiabilities.map((al, alKey) => {

                    let limit = (_.has(al, 'limit') && al.limit == "0.00") ? "" : al.limit
                    let balance = (_.has(al, 'balance') && al.balance == "0.00") ? "" : al.balance
                    let repaymentAmount = (_.has(al, 'repaymentAmount') && al.repaymentAmount == "0.00") ? "" : al.repaymentAmount

                    return {
                        financier: al.ownedOutright ? (al.financier ? true : false) : true,
                        limit: al.ownedOutright ? (limit ? true : false) : true,
                        balance: al.ownedOutright ? (balance ? true : false) : true,
                        repaymentAmount: al.ownedOutright ? (repaymentAmount ? true : false) : true,
                        frequency: al.ownedOutright ? (al.frequency ? true : false) : true,
                        totalMonths: al.ownedOutright ? (al.totalMonths ? true : false) : true,
                        startDate: al.ownedOutright ? (al.startDate ? true : false) : true
                    }
                })
            } else {
                return [{
                    financier: true,
                    limit: true,
                    balance: true,
                    repaymentAmount: true,
                    frequency: true,
                    totalMonths: true,
                    startDate: true,
                }]
            }
        })

        sharedUnsecuredLiabilities.forEach(applicant => {
            let validateDataMulti = []
            if (applicant) {
                applicant.forEach(address => {
                    let validateData = {}
                    for (const [key, value] of Object.entries(validate[validation.section])) {
                        Vue.set(validateData, key, (value && !address[key] ? false : true))
                    }
                    validateDataMulti.push(Object.values(validateData).every(item => item === true))
                })
                validateDataArray.push(validateDataMulti)
            }
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Expenses
    // ====================================
    validateExpenses(state, validation) {
        let validateDataArray = []
        let applicantStatus = $store.getters["hems/applicantStatus"]
        let validating = $store.getters["hems/validating"]
        let note = $store.getters["hems/note"]
        let passedHems = Object.values(applicantStatus).every(item => item === true)

        applicantStatus = applicantStatus.map(status => {
            return {hems: status}
        })

        if (!passedHems && note) {
            applicantStatus = applicantStatus.map(status => {
                return {hems: true}
            })
        }

        applicantStatus.forEach(status => {
            let validateData = {}
            for (const [key, value] of Object.entries(validate[validation.section])) {
                Vue.set(validateData, key, (value && !status[key] ? false : true))
            }
            validateDataArray.push(Object.values(validateData).every(item => item === true))
        })

        state[validation.section] = validateDataArray

    },

    // ====================================
    // Finances Summary
    // ====================================
    validateFinancesSummary(state, validation) {
        state[validation.section] = Object.values(state.expenses).every(item => item === true)
    },

    // ====================================
    // References
    // ====================================
    validateReferences(state, validation) {
        let validateDataArray = []

        let references = validation.data.map((applicant, key) => {
            let relationshipTypes = []
            return applicant.personalReferencesInfo.map((reference, employmentKey) => {
                relationshipTypes.push(reference.relationship_type_id)
                const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
                let relatives = countOccurrences(relationshipTypes, "1");

                return {
                    unitNumber: _.get(reference, 'addressComponents.unit_number') ? true : false,
                    streetNumber: _.get(reference, 'addressComponents.street_number') ? true : false,
                    streetName: _.get(reference, 'addressComponents.route') ? true : false,
                    suburb: _.get(reference, 'addressComponents.locality') ? true : false,
                    state: _.get(reference, 'addressComponents.administrative_area_level_1') ? true : false,
                    postalCode: _.get(reference, 'addressComponents.postal_code') ? true : false,
                    country: _.get(reference, 'addressComponents.country') ? true : false,
                    name: reference.name ? (reference.name.trim().indexOf(' ') >= 0 && reference.name !== "Firstname Lastname" ? true : false) : false,
                    phone: reference.phone ? true : false,
                    relationship: reference.relationship_type_id ? (relatives == 1 ? true : false) : false,
                    is_emergency: reference.is_emergency ? (reference.is_emergency !== 0 ? true : false) : false
                }
            })
        })

        references.forEach(applicant => {
            let validateDataMulti = []
            applicant.forEach(address => {
                let validateData = {}
                for (const [key, value] of Object.entries(validate[validation.section])) {
                    Vue.set(validateData, key, (value && !address[key] ? false : true))
                }
                validateDataMulti.push(Object.values(validateData).every(item => item === true))
            })
            validateDataArray.push(validateDataMulti)
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Dealer Details
    // ====================================
    validateDealerDetails(state, validation) {
        let validateData = {}
        let dealerDetials = {
            id: validation.data.id ? true : false,
            name: validation.data.name ? true : false,
            email: validation.data.email ? true : false,
            mobile: validation.data.mobile ? true : false,
        }

        for (const [key, value] of Object.entries(validate['dealerDetails'])) {
            Vue.set(validateData, key, (value && !dealerDetials[key] ? false : true))
        }

        state['sellerDetails'] = Object.values(validateData).every(item => item === true)
    },

    // ====================================
    // Prrivate Seller Details
    // ====================================
    validatePrivateSellerDetails(state, validation) {
        let validateData = {}
        let sellerDetails = {
            id: validation.data.id ? true : false,
            firstName: validation.data.first_name ? true : false,
            middleName: validation.data.middle_name ? true : false,
            lastName: validation.data.last_name ? true : false,
            homePhone: validation.data.home_phone ? true : false,
            phone: validation.data.phone ? true : false,
            email: validation.data.email ? true : false,
            unitNumber: validation.data.address.unit_number ? true : false,
            streetNumber: validation.data.address.street_number ? true : false,
            streetName: validation.data.address.route ? true : false,
            suburb: validation.data.address.locality ? true : false,
            state: validation.data.address.administrative_area_level_1 ? true : false,
            postalCode: validation.data.address.postal_code ? true : false,
            country: validation.data.address.country ? true : false,
        }
        for (const [key, value] of Object.entries(validate['privateSellerDetails'])) {
            Vue.set(validateData, key, (value && !sellerDetails[key] ? false : true))
        }
        state['sellerDetails'] = Object.values(validateData).every(item => item === true)
    },

    // ====================================
    // Business Information
    // ====================================
    validateBusinessInformation(state, validation) {
        let validateData = {}
        let businessInformation = {
            businessType: validation.data.businessType ? true : false,
            abn: validation.data.abn ? true : false,
            registeredBusinessName: validation.data.registeredBusinessName ? true : false,
            establishmentDate: validation.data.establishment_date ? true : false,
            gstRegistered: validation.data.gstRegistered ? true : false,
            dateFirstRegisteredForGst: validation.data.dateFirstRegisteredForGst ? true : false,
            industryType: validation.data.industryType ? true : false,
            website: validation.data.website ? true : false,
            acn: validation.data.acn ? true : false,
            description: validation.data.description ? true : false,
            unitNumber: validation.data.businessAddress.unit_number ? true : false,
            streetNumber: validation.data.businessAddress.street_number ? true : false,
            streetName: validation.data.businessAddress.route ? true : false,
            suburb: validation.data.businessAddress.locality ? true : false,
            state: validation.data.businessAddress.administrative_area_level_1 ? true : false,
            postalCode: validation.data.businessAddress.postal_code ? true : false,
            country: validation.data.businessAddress.country ? true : false,
            businessMobile: validation.data.businessAddress.businessMobile ? true : false,
            businessEmail: validation.data.businessAddress.businessEmail ? true : false,
            businessLandline: validation.data.businessAddress.businessLandline ? true : false,
            numberOfDirectors: validation.data.businessAddress.numberOfDirectors ? true : false,
            accountantFirm: validation.data.accountantDetails.nameOfFirm ? true : false,
            accountantContact: validation.data.accountantDetails.nameOfContact ? true : false,
            accountantPhone: validation.data.accountantDetails.phone ? true : false,
            accountantEmail: validation.data.accountantDetails.email ? true : false,
            trustee: validation.data.businessType == "trust" ? (validation.data.trustee ? true : false) : true,
        }
        for (const [key, value] of Object.entries(validate[validation.section])) {
            Vue.set(validateData, key, (value && !businessInformation[key] ? false : true))
        }

        state[validation.section] = Object.values(validateData).every(item => item === true)
    },

    // ====================================
    // Director Details
    // ====================================
    validateCommercialApplicantInformation(state, validation) {

        let validateDataArray = []
        let directorDetails = validation.data.map(applicant => {

            let ownership = (_.has(applicant, 'ownership_value') && (applicant.ownership_value == "0.00" || applicant.ownership_value == "0")) ? "" : applicant.ownership_value

            return {
                ownership: applicant.ownership_value ? true : false,
                ownershipType: ownership ? String(applicant.commercial_ownership_type) ? true : false : true,
                title: applicant.applicantTitle ? true : false,
                firstName: applicant.firstName ? true : false,
                lastName: applicant.lastName ? true : false,
                phone: applicant.phone ? true : false,
                homePhone: applicant.homePhone ? true : false,
                email: applicant.email ? true : false,
                email2: applicant.email2 ? true : false,
                dob: applicant.dob ? true : false,
                maritalStatus: applicant.maritalStatus ? true : false,
                residentialStatus: applicant.residentialStatus ? true : false,
                licenseNumber: applicant.licenseNumber ? true : false,
                licenseExpiry: applicant.licenseExpiry ? true : false,
                licenseState: applicant.licenseState ? true : false,
                licenseType: applicant.licenseType ? true : false,
            }
        })

        directorDetails.forEach(applicantDetail => {
            let validateData = {}
            for (const [key, value] of Object.entries(validate[validation.section])) {
                Vue.set(validateData, key, (value && !applicantDetail[key] ? false : true))
            }
            validateDataArray.push(Object.values(validateData).every(item => item === true))
        })
        state[validation.section] = validateDataArray
    },

    // ====================================
    // Business Unsecured Liabilities
    // ====================================
    validateBusinessUnsecuredLiabilities(state, validation) {
        let validateDataArray = []
        let liabilities = [{
            financier: true,
            limit: true,
            balance: true,
            repaymentAmount: true,
            frequency: true,
            totalMonths: true,
            startDate: true,
        }]

        if (!_.isEmpty(validation.data.expandedFinancialDetails.liabilities)) {

            liabilities = validation.data.expandedFinancialDetails.liabilities.map((liability, key) => {

                let limit = (_.has(liability, 'limit') && liability.limit == "0.00") ? "" : liability.limit
                let balance = (_.has(liability, 'balance') && liability.balance == "0.00") ? "" : liability.balance
                let repaymentAmount = (_.has(liability, 'repaymentAmount') && liability.repaymentAmount == "0.00") ? "" : liability.repaymentAmount

                return {
                    financier: liability.ownedOutright ? (liability.financier ? true : false) : true,
                    limit: liability.ownedOutright ? (limit ? true : false) : true,
                    balance: liability.ownedOutright ? (balance ? true : false) : true,
                    repaymentAmount: liability.ownedOutright ? (repaymentAmount ? true : false) : true,
                    frequency: liability.ownedOutright ? (liability.frequency ? true : false) : true,
                    totalMonths: liability.ownedOutright ? (liability.totalMonths ? true : false) : true,
                    startDate: liability.ownedOutright ? (liability.startDate ? true : false) : true
                }
            })
        }

        liabilities.forEach(unsecuredLiability => {
            let validateData = {}
            for (const [key, value] of Object.entries(validate[validation.section])) {
                Vue.set(validateData, key, (value && !unsecuredLiability[key] ? false : true))
            }
            validateDataArray.push(Object.values(validateData).every(item => item === true))
        })

        state[validation.section] = validateDataArray
    },

    // ====================================
    // Business Assets And Liabilities
    // ====================================
    validateBusinessAssetsLiabilities(state, validation) {

        let validateDataArray = []
        let assetsAndLiabilities = [false]
        let totalIncomeServicing = validation.data.totalIncomeServicing <= "0.00" ? "" : validation.data.totalIncomeServicing

        if (!_.isEmpty(validation.data.expandedFinancialDetails.assetsAndLiabilities)) {

            assetsAndLiabilities = validation.data.expandedFinancialDetails.assetsAndLiabilities.map((al, key) => {

                let isVehicle = false
                if (_.has(al, 'assetLiabilityType.value')) {
                    isVehicle = [
                        'COMMERCIAL_VEHICLE'
                    ].includes(al.assetLiabilityType.value);
                }

                let assetValueZero = (_.has(al, 'assetValue') && al.assetValue == "0.00") ? "" : al.assetValue
                let limit = (_.has(al, 'limit') && al.limit == "0.00") ? "" : al.limit
                let balance = (_.has(al, 'balance') && al.balance == "0.00") ? "" : al.balance
                let repaymentAmount = (_.has(al, 'repaymentAmount') && al.repaymentAmount == "0.00") ? "" : al.repaymentAmount

                return {
                    assetValue: al.assetValue ? true : false,
                    financier: (assetValueZero || balance) && al.ownedOutright ? (al.financier ? true : false) : true,
                    limit: (assetValueZero || balance) && al.ownedOutright ? (limit ? true : false) : true,
                    balance: (assetValueZero || balance) && al.ownedOutright ? (balance ? true : false) : true,
                    repaymentAmount: (assetValueZero || balance) && al.ownedOutright ? (repaymentAmount ? true : false) : true,
                    frequency: (assetValueZero || balance) && al.ownedOutright ? (al.frequency ? true : false) : true,
                    totalMonths: (assetValueZero || balance) && al.ownedOutright ? (al.totalMonths ? true : false) : true,
                    startDate: (assetValueZero || balance) && al.ownedOutright ? (al.startDate ? true : false) : true,
                    year: (assetValueZero || balance) && isVehicle ? (al.year ? true : false) : true,
                    nvic: (assetValueZero || balance) && isVehicle ? (al.nvic ? true : false) : true,
                    totalIncomeServicing: totalIncomeServicing ? true : false
                }
            })
            assetsAndLiabilities.forEach(assetAndLiability => {
                let validateData = {}
                for (const [key, value] of Object.entries(validate[validation.section])) {
                    Vue.set(validateData, key, (value && !assetAndLiability[key] ? false : true))
                }
                validateDataArray.push(Object.values(validateData).every(item => item === true))
            })
            state[validation.section] = Object.values(validateDataArray).every(item => item === true)
        } else {
            state[validation.section] = totalIncomeServicing ? true : false
        }
    },

    // ====================================
    // Direct Debit Information
    // ====================================
    validateDirectDebit(state, validation) {
        let validateData = {}
        let validateAccountName = () => {
            if (validation.data.bsb_number || validation.data.account_number) {
                return validation.data.account_name ? true : false
            } else {
                return true
            }
        }
        let validateBsbNumber = () => {
            if (validation.data.account_name || validation.data.account_number) {
                return validation.data.bsb_number ? true : false
            } else {
                return true
            }
        }
        let validateAccountNumber = () => {
            if (validation.data.account_name || validation.data.bsb_number) {
                return validation.data.account_number ? true : false
            } else {
                return true
            }
        }
        let directDebit = {
            accountName: validateAccountName(),
            bsbNumber: validateBsbNumber(),
            accountNumber: validateAccountNumber()
        }

        for (const [key, value] of Object.entries(validate[validation.section])) {
            Vue.set(validateData, key, (value && !directDebit[key] ? false : true))
        }

        state[validation.section] = Object.values(validateData).every(item => item === true)
    },

    // ====================================
    // Emergency Contacts
    // ====================================
    validateEmergencyContact(state, validation) {
        let validateData = {}

        let validateFirstName = () => {
            if (validation.data.last_name || validation.data.phone || validation.data.email || validation.data.relationship) {
                return validation.data.first_name ? true : false
            } else {
                return true
            }
        }
        let validateLastName = () => {
            if (validation.data.first_name || validation.data.phone || validation.data.email || validation.data.relationship) {
                return validation.data.last_name ? true : false
            } else {
                return true
            }
        }
        let validatePhone = () => {
            if (validation.data.first_name || validation.data.last_name || validation.data.email || validation.data.relationship) {
                return validation.data.phone ? true : false
            } else {
                return true
            }
        }
        let validateEmail = () => {
            if (validation.data.first_name || validation.data.last_name || validation.data.phone || validation.data.relationship) {
                return validation.data.email ? true : false
            } else {
                return true
            }
        }
        let validateRelationship = () => {
            if (validation.data.first_name || validation.data.last_name || validation.data.phone || validation.data.email) {
                return validation.data.relationship ? true : false
            } else {
                return true
            }
        }

        let emergencyContact = {
            first_name: validateFirstName(),
            last_name: validateLastName(),
            phone: validatePhone(),
            email: validateEmail(),
            relationship: validateRelationship()
        }

        for (const [key, value] of Object.entries(validate[validation.section])) {
            Vue.set(validateData, key, (value && !emergencyContact[key] ? false : true))
        }

        state[validation.section] = Object.values(validateData).every(item => item === true)
    },
    validateQualifyingQuestionnaire(state, validation) {
        state[validation.section] = _.get(validation, 'data.finalise', false)
    }
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {
    validateData({dispatch, commit, state}, data) {
        if (_.isArray(data.section)) {
            data.section.forEach(section => {
                let validateData = data
                validateData.section = section
                commit('validate' + _.upperFirst(section), validateData)
            })
        } else {
            if (_.has(data, 'type', false)) {
                commit('validate' + _.upperFirst(data.type), data)
            } else {
                commit('validate' + _.upperFirst(data.section), data)
            }
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
